export default __webpack_public_path__ + "assets/home_phone_small.2acbfa52.webp";